import React from 'react';
import styled from 'styled-components';

// styling for svg's
const SVG = styled.svg`
  height: inherit;
  width: inherit;
  max-width: 3em;
  max-height:3em;
  position: relative;
  left: 0.9em;
  margin-top: 10px;
  font-size: 50px;
  fill: #E6373C;
  /*transition: all 0.15s ease-in-out;*/
    @media screen and (max-width: 920px) {
    font-size: 40px;
  }
  @media screen and (max-width: 500px) {
  
  font-size: 35px;
  position: relative;
  bottom: 0.2em;
  left: -2em;
}

`;


const IconDistress = props => {
    const { icon, variant, disabled, notext, className } = props;

    switch (icon) {
    case 'distress':
        return (
             <SVG
                 xmlns='http://www.w3.org/2000/SVG'
                 variant={variant || 'primary'}
                 className={className}
                 data-icon-name={icon}
                 data-disabled={disabled}
                 style={notext ? { marginRight: '0px' } : { marginRight: '16px' }}
                 viewBox='0 0 40 40'
                  >
                <symbol id='distress' data-name='distress'>
                <title>distress</title>
                </symbol>
                <path d="M0 0h24v24H0z" fill="none"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                <use href={icon ? '#' + icon : '#check'} />{' '}
             </SVG>
               );
               case 'restaurant':
                return (
                  <SVG
                    xmlns='http://www.w3.org/2000/SVG'
                    variant={variant || 'primary'}
                    className={className}
                    data-icon-name={icon}
                    data-disabled={disabled}
                    style={notext ? { marginRight: '0px' } : { marginRight: '16px' }}
                    viewBox='0 0 40 40'
                  >
                    <symbol id='restaurant' data-name='restaurant'>
                      <title>restaurant</title>
                    </symbol>
                    <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>  
                    <use href={icon ? '#' + icon : '#check'} />{' '}
                  </SVG>
                );
        default:
            // do nothing
}
};

export default IconDistress;
